export const handleChangeInputUserAuthenticationgPage = (name, value) => ({
    type: 'CHANGE_INPUT_PAGE_USER_AUTHENTICATION', name, value
});